<script>
    import {createEventDispatcher} from "svelte";
    import {I_REQUEST} from "../../../../../lib/datatypes";
    import {firstNameFromRawPerson, fullNameFromRawPerson, lastNameFromRawPerson} from "../stores/misc";
    import {now, toDate, getTimeDiffAsShortText} from "../../../../../lib/dates_times";
    import {people} from "../stores/people";
    import Label from "./Label.svelte";
    import SmallNextAction from "./SmallNextAction.svelte";

    const dispatch = createEventDispatcher();
    export let requests_arr_list;

    const onItemClicked = id => {
        dispatch('requestClicked', {id:id});
    }
</script>


<table class="min-w-full divide-y divide-gray-300">
<!--    <thead>-->
<!--    <tr>-->
<!--        <th scope="col" class="py-3.5 pl-0 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Name</th>-->
<!--        <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">Last Name</th>-->
<!--        <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">Position</th>-->
<!--        <th scope="col" class="relative py-3.5 pl-3 pr-0 text-left text-sm font-semibold text-gray-900 sm:pr-6">Company</th>-->
<!--    </tr>-->
<!--    </thead>-->
    <tbody class="divide-y divide-gray-200 bg-white">
    {#each requests_arr_list as request_arr (request_arr[I_REQUEST.ID])}
        <tr data-id="{request_arr[I_REQUEST.ID]}" on:click={() => onItemClicked(request_arr[I_REQUEST.ID])}
            class="cursor-pointer">
            <td class="w-1/3 max-w-0 py-4 pl-0 pr-3 text-sm text-gray-700 align-top sm:w-auto sm:max-w-none sm:pl-6">
                <span class="inline-flex align-text-bottom"><Label type={'person'}></Label></span>
                {fullNameFromRawPerson($people.lookup[request_arr[I_REQUEST.ID_PERSON]])}
                <dl class="font-normal lg:hidden">
                    <dt class="sr-only">Updated</dt>
                    <dd class="mt-1 text-gray-400">
                        <time datetime="{request_arr[I_REQUEST.UPDATED]}" title="{request_arr[I_REQUEST.UPDATED]}">{getTimeDiffAsShortText(now().valueOf() - toDate(request_arr[I_REQUEST.UPDATED]))}</time>
                    </dd>
                </dl>
            </td>
            <td class="hidden px-3 py-4 text-sm text-gray-500 align-top lg:table-cell">
                <time datetime="{request_arr[I_REQUEST.UPDATED]}" title="{request_arr[I_REQUEST.UPDATED]}">{getTimeDiffAsShortText(now().valueOf() - toDate(request_arr[I_REQUEST.UPDATED]))}</time>
            </td>
<!--            <td class="hidden px-3 py-4 text-sm text-gray-500 align-top sm:table-cell">{$additional_people_info[request_arr[I_REQUEST.ID]][0].position}</td>-->
            <td class="w-2/3 sm:w-auto py-4 pl-3 pr-6 align-top sm:pr-0">
                <p class="text font-medium text-gray-800 mb-2">{@html request_arr[I_REQUEST.TITLE]}</p>
                <SmallNextAction next_action={request_arr[I_REQUEST.NEXT_ACTION]}></SmallNextAction>
            </td>
        </tr>
    {:else}
        <tr><td class="text font-medium italic text-gray-400 py-4">No Requests</td></tr>
    {/each}
    </tbody>
</table>


<style></style>